import { render, staticRenderFns } from "./Abrangencia.vue?vue&type=template&id=4da53884&scoped=true&"
import script from "./Abrangencia.vue?vue&type=script&lang=js&"
export * from "./Abrangencia.vue?vue&type=script&lang=js&"
import style0 from "./Abrangencia.vue?vue&type=style&index=0&id=4da53884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da53884",
  null
  
)

export default component.exports